import React from 'react';

import { NavItemActionsMenu } from '@atlassian/navigation-drag-and-drop';

import { useItemProperties } from '../../../controllers/items-and-shortcuts-provider/use-item-properties';

import { useNavItemReorderingContext } from './use-nav-item-reordering-context';
import { useNavItemVisibilityActions } from './use-nav-item-visibility-actions';
import { useReorderingActions } from './use-reordering-actions';

export type NavItemActionsProps = {
	itemMenuId: string;
};

export default function NavItemActions({ itemMenuId }: NavItemActionsProps) {
	const { moveUpPosition, moveDownPosition } = useNavItemReorderingContext(itemMenuId);
	const { moveToTop, moveToBottom, moveUp, moveDown } = useReorderingActions(itemMenuId);
	const { getItemProperties } = useItemProperties();
	const { isReorderable, isHideable, isVisible } = getItemProperties(itemMenuId) || {};
	const { hideItem, showItem } = useNavItemVisibilityActions(itemMenuId);

	if (!isReorderable && !isHideable) {
		return null;
	}

	return (
		<div data-testid="gsn-nav-item-actions">
			<NavItemActionsMenu
				isReorderable={isReorderable}
				isVisible={isVisible}
				canToggleVisibility={isHideable}
				moveUp={moveUp}
				moveDown={moveDown}
				moveToTop={moveToTop}
				moveToBottom={moveToBottom}
				canMoveUp={moveUpPosition !== false}
				canMoveDown={moveDownPosition !== false}
				toggleVisibility={isVisible ? hideItem : showItem}
			/>
		</div>
	);
}
